import { render } from "./Join.vue?vue&type=template&id=6f3edbcf&bindings={\"eventId\":\"props\",\"eventName\":\"props\",\"joining\":\"data\",\"join\":\"options\",\"getImgUrl\":\"options\",\"isAuthenticated\":\"options\",\"user\":\"options\"}"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"
script.render = render

export default script